import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type OutstandingInvoicesSortField =
    | "clientName"
    | "communityName"
    | "advisorName"
    | "moveDate"
    | "serial"
    | "amountCents"
    | "remainingBalanceCents"
    | "dueDate";

interface OutstandingInvoicesReportState {
    sortField: OutstandingInvoicesSortField;
    sortAsc: boolean;
    advisorId: string | undefined;
}

const initialState: OutstandingInvoicesReportState = {
    sortField: "remainingBalanceCents",
    sortAsc: false,
    advisorId: undefined,
};

export const outstandingInvoicesReportSlice = createSlice({
    name: "outstandingInvoicesReport",
    initialState,
    reducers: {
        update: (
            state,
            action: PayloadAction<Partial<OutstandingInvoicesReportState>>,
        ) => {
            return { ...state, ...action.payload };
        },
    },
});
